export default "__VITE_ASSET__GuYxGX8P__"